import { combineReducers } from "redux";
import {
  CHANGE_DOCTOR_IS_IN_CAMPAIGN_REQUEST,
  CHANGE_DOCTOR_STATUS_REQUEST,
  CREATE_DOCTOR_INSURANCE_REQUEST,
  CREATE_DOCTOR_PROFESSION_REQUEST,
  DELETE_DOCTOR_IMAGE_REQUEST,
  DELETE_DOCTOR_INSURANCE_REQUEST,
  DELETE_DOCTOR_PROFESSION_REQUEST,
  FETCH_DOCTOR_PACKAGE_REQUEST,
  FETCH_DOCTOR_REQUEST,
  FETCH_DOCTOR_WEIGHTING_RESULTS_REQUEST,
  FETCH_DOCTOR_WALLET_LIST_REQUEST,
  FETCH_DOCTOR_WALLET_LOG_REQUEST,
  UPDATE_DOCTOR_HAS_FOREIGN_CONSULT_REQUEST,
  UPDATE_DOCTOR_IGNORE_SPECIALTIES_REQUEST,
  UPDATE_DOCTOR_IMAGE_REQUEST,
  UPDATE_DOCTOR_PACKAGE_REQUEST,
  UPDATE_DOCTOR_PACKAGE_STATUS_REQUEST,
  UPDATE_DOCTOR_PROFESSION_REQUEST,
  UPDATE_DOCTOR_REQUEST,
  UPDATE_DOCTOR_VERIFIED_REQUEST,
  DELETE_DOCTOR_HEALTH_TAG_REQUEST,
  UPDATE_DOCTOR_HEALTH_TAG_REQUEST,
  CREATE_DOCTOR_HEALTH_TAG_REQUEST,
  DELETE_DOCTOR_APPROACH_REQUEST,
  CREATE_DOCTOR_APPROACH_REQUEST,
  UPDATE_DOCTOR_APPROACH_REQUEST,
  FETCH_DOCTOR_PACKAGE_PRICES_REQUEST,
  UPDTAE_ASSESSMENT_INTERPRETATION_ENABLED_REQUEST,
} from "./constants";
import { CREATE_DOCTOR_OFFICE_IMAGE_REQUEST, DELETE_DOCTOR_OFFICE_IMAGE_REQUEST } from "../images/constants";
import { UPDATE_OFFICES_REQUEST } from "../offices/constants";
import { CREATE_DOCTOR_REQUEST } from "../doctors/constants";
import { UPDATE_COMMENT_REQUEST } from "../comments/constants";
import { DoctorDetail } from "../types";
import { Action, PackagePriceState } from "./types";
import { Action as DoctorsAction } from "../doctors/types";
import { Action as CommentsAction } from "../comments/types";
import { Action as ImagesAction } from "../images/types";
import { Action as OfficesAction } from "../offices/types";
import { getFailureActionType, getSuccessActionType } from "../utils";
import { DoctorWeightValuesState } from "./types";

type Item = Partial<DoctorDetail>;

function item(state: Item = {}, action: Action | CommentsAction | DoctorsAction | OfficesAction | ImagesAction): Item {
  let selected = null;
  let selectedOffice = null;
  switch (action.type) {
    case getSuccessActionType(FETCH_DOCTOR_REQUEST):
    case getSuccessActionType(UPDATE_DOCTOR_REQUEST):
    case getSuccessActionType(CREATE_DOCTOR_REQUEST):
    case getSuccessActionType(CHANGE_DOCTOR_STATUS_REQUEST):
    case getSuccessActionType(UPDATE_DOCTOR_HAS_FOREIGN_CONSULT_REQUEST):
    case getSuccessActionType(CHANGE_DOCTOR_IS_IN_CAMPAIGN_REQUEST):
    case getSuccessActionType(UPDATE_DOCTOR_VERIFIED_REQUEST):
    case getSuccessActionType(UPDATE_DOCTOR_IMAGE_REQUEST):
    case getSuccessActionType(DELETE_DOCTOR_IMAGE_REQUEST):
    case getSuccessActionType(UPDTAE_ASSESSMENT_INTERPRETATION_ENABLED_REQUEST):
      return action.payload;

    case getSuccessActionType(CREATE_DOCTOR_PROFESSION_REQUEST): {
      const professions = state.doctorProfessions ? [...state.doctorProfessions, action.payload] : action.payload;
      return { ...state, doctorProfessions: professions };
    }

    case getSuccessActionType(CREATE_DOCTOR_HEALTH_TAG_REQUEST): {
      const healthTags = state.doctorHealthTags ? [...state.doctorHealthTags, action.payload] : action.payload;
      return { ...state, doctorHealthTags: healthTags };
    }

    case getSuccessActionType(CREATE_DOCTOR_APPROACH_REQUEST): {
      const approaches = state.doctorApproaches ? [...state.doctorApproaches, action.payload] : action.payload;
      return { ...state, doctorApproaches: approaches };
    }

    case DELETE_DOCTOR_PROFESSION_REQUEST:
      selected = state.doctorProfessions?.map((dp) =>
        dp.id === action.data.doctorId ? { ...dp, isFetching: true } : dp
      );
      return { ...state, doctorProfessions: selected };

    case getSuccessActionType(DELETE_DOCTOR_PROFESSION_REQUEST):
      selected = state.doctorProfessions?.filter((dp) => dp.id !== action.data.doctorId);
      return { ...state, doctorProfessions: selected };

    case getFailureActionType(DELETE_DOCTOR_PROFESSION_REQUEST):
      selected = state.doctorProfessions?.map((dp) =>
        dp.id === action.data.doctorId ? { ...dp, isFetching: false } : dp
      );
      return { ...state, doctorProfessions: selected };

    case DELETE_DOCTOR_HEALTH_TAG_REQUEST:
      selected = state.doctorHealthTags?.map((dht) =>
        dht.id === action.data.doctorId ? { ...dht, isFetching: true } : dht
      );
      return { ...state, doctorHealthTags: selected };

    case getSuccessActionType(DELETE_DOCTOR_HEALTH_TAG_REQUEST):
      selected = state.doctorHealthTags?.filter((dht) => dht.id !== action.data.doctorId);
      return { ...state, doctorHealthTags: selected };

    case getFailureActionType(DELETE_DOCTOR_HEALTH_TAG_REQUEST):
      selected = state.doctorHealthTags?.map((dht) =>
        dht.id === action.data.doctorId ? { ...dht, isFetching: false } : dht
      );
      return { ...state, doctorHealthTags: selected };

    case DELETE_DOCTOR_APPROACH_REQUEST:
      selected = state.doctorApproaches?.map((da) => (da.id === action.data.id ? { ...da, isFetching: true } : da));
      return { ...state, doctorApproaches: selected };

    case getSuccessActionType(DELETE_DOCTOR_APPROACH_REQUEST):
      selected = state.doctorApproaches?.filter((da) => da.id !== action.data.id);
      return { ...state, doctorApproaches: selected };

    case getFailureActionType(DELETE_DOCTOR_APPROACH_REQUEST):
      selected = state.doctorApproaches?.map((da) => (da.id === action.data.id ? { ...da, isFetching: false } : da));
      return { ...state, doctorApproaches: selected };

    case UPDATE_DOCTOR_PROFESSION_REQUEST:
      selected = state.doctorProfessions?.map((dp) =>
        dp.id === action.data.doctorProfessionId
          ? {
              ...dp,
              isFetching: true,
            }
          : dp
      );
      return { ...state, doctorProfessions: selected };

    case getSuccessActionType(UPDATE_DOCTOR_PROFESSION_REQUEST):
      selected = state.doctorProfessions?.map((dp) =>
        dp.id === action.data.doctorProfessionId
          ? {
              ...action.payload,
              isFetching: false,
            }
          : dp
      );
      return { ...state, doctorProfessions: selected };

    case getFailureActionType(UPDATE_DOCTOR_PROFESSION_REQUEST):
      selected = state.doctorProfessions?.map((dp) =>
        dp.id === action.data.doctorProfessionId
          ? {
              ...dp,
              isFetching: false,
            }
          : dp
      );
      return { ...state, doctorProfessions: selected };

    case UPDATE_DOCTOR_HEALTH_TAG_REQUEST:
      selected = state.doctorHealthTags?.map((dht) =>
        dht.id === action.data.doctorHealthTagId
          ? {
              ...dht,
              isFetching: true,
            }
          : dht
      );
      return { ...state, doctorHealthTags: selected };

    case getSuccessActionType(UPDATE_DOCTOR_HEALTH_TAG_REQUEST):
      selected = state.doctorHealthTags?.map((dht) =>
        dht.id === action.data.doctorHealthTagId
          ? {
              ...action.payload,
              isFetching: false,
            }
          : dht
      );
      return { ...state, doctorHealthTags: selected };

    case getFailureActionType(UPDATE_DOCTOR_HEALTH_TAG_REQUEST):
      selected = state.doctorHealthTags?.map((dht) =>
        dht.id === action.data.doctorHealthTagId
          ? {
              ...dht,
              isFetching: false,
            }
          : dht
      );
      return { ...state, doctorHealthTags: selected };

    case UPDATE_DOCTOR_APPROACH_REQUEST:
      selected = state.doctorApproaches?.map((da) =>
        da.id === action.data.id
          ? {
              ...da,
              isFetching: true,
            }
          : da
      );
      return { ...state, doctorApproaches: selected };

    case getSuccessActionType(UPDATE_DOCTOR_APPROACH_REQUEST):
      selected = state.doctorApproaches?.map((da) =>
        da.id === action.data.id
          ? {
              ...action.payload,
              isFetching: false,
            }
          : da
      );
      return { ...state, doctorApproaches: selected };

    case getFailureActionType(UPDATE_DOCTOR_APPROACH_REQUEST):
      selected = state.doctorApproaches?.map((da) =>
        da.id === action.data.id
          ? {
              ...da,
              isFetching: false,
            }
          : da
      );
      return { ...state, doctorApproaches: selected };

    case getSuccessActionType(UPDATE_OFFICES_REQUEST):
      selectedOffice = state.offices?.map((office) =>
        office.id === action.data.officeId ? { ...office, ...action.payload } : office
      );
      return { ...state, offices: selectedOffice };

    case getSuccessActionType(CREATE_DOCTOR_INSURANCE_REQUEST): {
      const insurances = state.doctorInsurances ? [...state.doctorInsurances, action.payload] : action.payload;
      return { ...state, doctorInsurances: insurances };
    }

    case getSuccessActionType(DELETE_DOCTOR_INSURANCE_REQUEST):
      return {
        ...state,
        doctorInsurances: state.doctorInsurances?.filter((DI) => DI.id !== action.data.insuranceId),
      };

    case getSuccessActionType(CREATE_DOCTOR_OFFICE_IMAGE_REQUEST):
      // todo: handle doctorId->itemId
      if (action.data.modelKey === "Doctor") {
        const images = state.images ? [...state.images, action.payload] : action.payload;
        return { ...state, images };
      } else return state;

    case getSuccessActionType(DELETE_DOCTOR_OFFICE_IMAGE_REQUEST):
      selected = state.images?.filter((img) => img.id !== action.data.imageId);
      return { ...state, images: selected };

    case getSuccessActionType(UPDATE_DOCTOR_PACKAGE_STATUS_REQUEST):
      return {
        ...state,
        doctorPackages: state.doctorPackages?.map((doctorPackage) =>
          doctorPackage.id === action.data.packageId ? action.payload : doctorPackage
        ),
      };

    case UPDATE_COMMENT_REQUEST:
      if (Object.entries(state).length === 0) return state;
      return {
        ...state,
        comments: state.comments?.map((comment) =>
          comment.id === action.data.commentId
            ? {
                ...comment,
                isFetching: true,
              }
            : comment
        ),
      };

    case getSuccessActionType(UPDATE_COMMENT_REQUEST):
      if (Object.entries(state).length === 0) return state;
      return {
        ...state,
        comments: state.comments?.map((comment) =>
          comment.id === action.data.commentId
            ? {
                ...comment,
                status: action.data.status,
                isFetching: false,
              }
            : comment
        ),
      };

    case getFailureActionType(UPDATE_COMMENT_REQUEST):
      if (Object.entries(state).length === 0) return state;
      return {
        ...state,
        comments: state.comments?.map((comment) =>
          comment.id === action.data.commentId
            ? {
                ...comment,
                isFetching: false,
              }
            : comment
        ),
      };

    case getSuccessActionType(UPDATE_DOCTOR_IGNORE_SPECIALTIES_REQUEST):
      return { ...state, ignoreSpecialties: action.payload.ignoreSpecialties };

    default:
      return state;
  }
}

function doctorPackage(state = [], action: Action) {
  switch (action.type) {
    case getSuccessActionType(FETCH_DOCTOR_PACKAGE_REQUEST):
      return action.payload;

    default:
      return state;
  }
}

function weightingResults(
  state: DoctorWeightValuesState = { currentPage: 0, pageCount: 1, data: [] },
  action: Action
): DoctorWeightValuesState {
  switch (action.type) {
    case getSuccessActionType(FETCH_DOCTOR_WEIGHTING_RESULTS_REQUEST):
      return action.payload;

    default:
      return state;
  }
}

function walletDetail(state = [], action: Action) {
  switch (action.type) {
    case getSuccessActionType(FETCH_DOCTOR_WALLET_LIST_REQUEST):
      return action.payload;

    default:
      return state;
  }
}

function walletLogs(state = [], action: Action) {
  switch (action.type) {
    case getSuccessActionType(FETCH_DOCTOR_WALLET_LOG_REQUEST):
      return action.payload;

    default:
      return state;
  }
}

function isFetching(state = false, action: Action | DoctorsAction | OfficesAction | ImagesAction) {
  switch (action.type) {
    case FETCH_DOCTOR_REQUEST:
    case UPDATE_DOCTOR_REQUEST:
    case CHANGE_DOCTOR_IS_IN_CAMPAIGN_REQUEST:
    case UPDATE_DOCTOR_VERIFIED_REQUEST:
    case UPDATE_DOCTOR_PACKAGE_REQUEST:
    case UPDATE_DOCTOR_PACKAGE_STATUS_REQUEST:
    case CREATE_DOCTOR_OFFICE_IMAGE_REQUEST:
    case CREATE_DOCTOR_REQUEST:
    case FETCH_DOCTOR_WEIGHTING_RESULTS_REQUEST:
    case FETCH_DOCTOR_WALLET_LIST_REQUEST:
    case FETCH_DOCTOR_WALLET_LOG_REQUEST:
    case UPDATE_DOCTOR_HAS_FOREIGN_CONSULT_REQUEST:
    case UPDTAE_ASSESSMENT_INTERPRETATION_ENABLED_REQUEST:
      return true;

    case getSuccessActionType(FETCH_DOCTOR_REQUEST):
    case getFailureActionType(FETCH_DOCTOR_REQUEST):
    case getSuccessActionType(CREATE_DOCTOR_REQUEST):
    case getFailureActionType(CREATE_DOCTOR_REQUEST):
    case getSuccessActionType(UPDATE_DOCTOR_REQUEST):
    case getFailureActionType(UPDATE_DOCTOR_REQUEST):
    case getSuccessActionType(UPDATE_DOCTOR_PACKAGE_REQUEST):
    case getFailureActionType(UPDATE_DOCTOR_PACKAGE_REQUEST):
    case getSuccessActionType(UPDATE_DOCTOR_PACKAGE_STATUS_REQUEST):
    case getFailureActionType(UPDATE_DOCTOR_PACKAGE_STATUS_REQUEST):
    case getSuccessActionType(CREATE_DOCTOR_OFFICE_IMAGE_REQUEST):
    case getFailureActionType(CREATE_DOCTOR_OFFICE_IMAGE_REQUEST):
    case getSuccessActionType(FETCH_DOCTOR_WEIGHTING_RESULTS_REQUEST):
    case getFailureActionType(FETCH_DOCTOR_WEIGHTING_RESULTS_REQUEST):
    case getSuccessActionType(FETCH_DOCTOR_WALLET_LIST_REQUEST):
    case getFailureActionType(FETCH_DOCTOR_WALLET_LIST_REQUEST):
    case getSuccessActionType(FETCH_DOCTOR_WALLET_LOG_REQUEST):
    case getFailureActionType(FETCH_DOCTOR_WALLET_LOG_REQUEST):
    case getSuccessActionType(UPDATE_DOCTOR_HAS_FOREIGN_CONSULT_REQUEST):
    case getFailureActionType(UPDATE_DOCTOR_HAS_FOREIGN_CONSULT_REQUEST):
    case getSuccessActionType(CHANGE_DOCTOR_IS_IN_CAMPAIGN_REQUEST):
    case getFailureActionType(CHANGE_DOCTOR_IS_IN_CAMPAIGN_REQUEST):
    case getSuccessActionType(UPDATE_DOCTOR_VERIFIED_REQUEST):
    case getFailureActionType(UPDATE_DOCTOR_VERIFIED_REQUEST):
    case getSuccessActionType(UPDTAE_ASSESSMENT_INTERPRETATION_ENABLED_REQUEST):
    case getFailureActionType(UPDTAE_ASSESSMENT_INTERPRETATION_ENABLED_REQUEST):
      return false;

    default:
      return state;
  }
}

function packages(state: PackagePriceState = {}, action: Action): PackagePriceState {
  switch (action.type) {
    case getSuccessActionType(FETCH_DOCTOR_PACKAGE_PRICES_REQUEST):
      return action.payload;

    default:
      return state;
  }
}

export const doctor = combineReducers({
  item,
  doctorPackage,
  packages,
  weightingResults,
  isFetching,
  walletDetail,
  walletLogs,
});
